import React from 'react';
import './SelectBox.css';
import { utmMediumOptions } from '../../modules/constants';



const SelectBox = props => {
  
  const onQuestionClick = (e) => {
    props.onQuestionClick(props.name);
  }

  return (
    <div className="parameter-input-box">
      <div className="parameter-top">
        <strong>{props.campaignTitle}</strong>
      </div>

      <div className="parameter-bottom">
        <div className="input-box-description">
          <label className="input-box-label">
            {props.label}
          </label>

          <button
            className="parameters-about-button waves-effect waves-light btn blue lighten-1"
            type="button"
            onClick={onQuestionClick}
          >?</button>
        </div>

        <select
          className="input-box-select"
          name={props.name}
          onChange={props.onChange}
          value={props.value}
        >
          <option defaultValue value=''></option>

          { utmMediumOptions.map((option, index) => {
            return <option key={option+index} value={option.value}>{option.label}</option>

          }) }
        </select>
      </div>
      
      <p className="input-box-text">{props.descriptionText}</p>
    </div>
  )
}

export default SelectBox;





// WEBPACK FOOTER //
// ./src/components/SelectBox/SelectBox.js